import Book from "./book/book";
import EpubCFI from "./utils/epubcfi";
import Rendition from "./rendition/rendition";
import Contents from "./rendition/contents";
import Layout from "./rendition/layout";
import ePub from "./epub";

export default ePub;
// export {
// 	Book,
// 	EpubCFI,
// 	Rendition,
// 	Contents,
// 	Layout
// };
